exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".percent[data-v-9a60a0e4]{font-size:25px;font-weight:600;margin-top:-9px}.completed[data-v-9a60a0e4]{font-weight:600;margin-left:1px;font-size:x-small;margin-top:-7px}", ""]);

// exports
